<ng-container class="app-container">
  <app-header></app-header>
  <router-outlet></router-outlet>
  <app-footer></app-footer>
</ng-container>
